import { useState } from "react";

const RecruitmentTechnologies = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const features = [
    {
      title: "Sourcing the Best",
      description:
        "Stay tuned for regular updates and valuable insights from our team of staffing experts.",
      icon: "https://ik.imagekit.io/satfy9rkc/Kapil%20Tech%20staffing%20Website/About%20US/work1-icon1.webp",
    },
    {
      title: "Volume Hiring",
      description:
        "Remember to keep your blog content informative, engaging, and relevant to your target audience.",
      icon: "https://ik.imagekit.io/satfy9rkc/Kapil%20Tech%20staffing%20Website/About%20US/work1-icon2.webp",
    },
    {
      title: "Partners in Team Building",
      description:
        "This will help drive traffic to your website and establish your agency as a trusted authority.",
      icon: "https://ik.imagekit.io/satfy9rkc/Kapil%20Tech%20staffing%20Website/About%20US/work1-icon3.webp",
    },
  ];

  return (
    <section className="w-full py-16 md:py-24" style={{ backgroundColor: "#ffffff" }}>
      <div className="container mx-auto w-full max-w-[1320px] px-4">
        <div className="mx-auto mb-12 max-w-3xl text-center">
          <span
            className="mb-4 inline-block rounded-md px-4 py-1.5 text-xs font-medium md:text-sm"
            style={{ backgroundColor: "#fff2e6", color: "#ff7a01" }}
          >
            Recruitment Technologies
          </span>

          <h2
            className="mb-4 text-3xl font-bold leading-tight md:text-4xl lg:text-5xl"
            style={{ color: "#081120" }}
          >
            Solving Recruitment Using Technology
          </h2>

          <p
            className="mx-auto max-w-3xl text-sm leading-relaxed md:text-base"
            style={{ color: "#77787b" }}
          >
            Whether you are seeking temporary assignments, placements, or
            executive-level positions, our curated hiring process keeps every
            step clear and efficient.
          </p>
        </div>

        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-12">
          <div
            className="overflow-hidden rounded-md border shadow-lg"
            style={{ borderColor: "#edf0f4" }}
          >
            <video
              src="https://ik.imagekit.io/satfy9rkc/Kapil%20Tech%20staffing%20Website/About%20US/recruiting.mp4"
              className="h-full min-h-[300px] w-full object-cover"
              autoPlay
              loop
              muted
              playsInline
            />
          </div>

          <div className="space-y-5">
            {features.map((feature, index) => {
              const isActive = hoveredIndex === index;

              return (
                <div
                  key={feature.title}
                  className="flex cursor-pointer items-start gap-4 rounded-md border p-5 shadow-md transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}
                  style={{
                    backgroundColor: isActive ? "#ff7a01" : "#ffffff",
                    borderColor: isActive ? "#ff7a01" : "#edf0f4",
                    color: isActive ? "#ffffff" : "#081120",
                  }}
                >
                  <div
                    className="flex h-12 w-12 flex-none items-center justify-center rounded-md"
                    style={{
                      backgroundColor: isActive ? "#ffffff" : "#fff2e6",
                    }}
                  >
                    <img
                      src={feature.icon}
                      alt=""
                      className="h-7 w-7 object-contain"
                    />
                  </div>

                  <div>
                    <h3
                      className="mb-2 text-lg font-bold leading-snug"
                      style={{ color: isActive ? "#ffffff" : "#081120" }}
                    >
                      {feature.title}
                    </h3>
                    <p
                      className="text-sm leading-relaxed md:text-base"
                      style={{
                        color: isActive
                          ? "rgba(255, 255, 255, 0.88)"
                          : "#77787b",
                      }}
                    >
                      {feature.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default RecruitmentTechnologies;
